import {
  aerospikeNamespaceForFlights,
  aerospikeIp,
  aerospikePort
} from '@stencil/flights-infra-config';

import {
  fillStoreSrp,
  fillStoreSeoFlightsToFlightsFrom,
  fillStoreSeoAirlines,
  fillStoreSeoCheapFlightsFlightSchedule,
  fillStoreSeoStaticPages,
  getRedirectPath,
  fillStoreSeoInternationalFlights
} from '@stencil/flights-fill-store';
import {
  populateStoreSeoSrpFlights,
  populateStoreSeoSrpDistance,
  populateStoreSeoSrpHiFlights,
  populateStoreSeoSrpFlightSchedule,
  populateStoreSeoSrpHiFlightSchedule,
  populateStoreSeoSrpAirlineSchedule,
  populateStoreSeoSrpHiAirlineSchedule,
  populateStoreSeoSrpFlightsTo,
  populateStoreSeoSrpHiFlightsTo,
  populateStoreSeoSrpFlightsFrom,
  populateStoreSeoSrpHiFlightsFrom,
  populateStoreSeoSrpAirlines,
  populateStoreSeoSrpCheapFlights,
  populateStoreSeoFlightSchedule,
  populateStoreSeoSrpInternationalFlights,
  populateStoreSeoSrpHiInternationalFlights,
  populateStoreSeoSrpInternationalFlightSchedule,
  populateStoreSeoSrpHiInternationalFlightSchedule,
  populateStoreSeoSrpInternationalAirlineSchedule,
  populateStoreSeoSrpHiInternationalAirlineSchedule,
  populateStoreSeoIntlFlightsTo,
  populateStoreSeoHiIntlFlightsTo,
  populateStoreSeoIntlFlightsFrom,
  populateStoreSeoHiIntlFlightsFrom,
  populateStoreSeoStaticPages
} from '@stencil/flights-fill-store/src/populate-store-seo';

import SrpSeoDweb from '../containers/SRP/srp-seo-dweb';
import SeoFlightsToFlightsFromDweb from '../containers/flights-to-flights-from/seo-flights-to-flights-from-dweb';
import SeoAirlinesDweb from '../containers/seo-airline/seo-airlines-dweb';
import SeoCheapFlightsDweb from '../containers/seo-cheap-flights/seo-cheap-flights-dweb';
import SeoFlightScheduleDweb from '../containers/flight-schedule/seo-flight-schedule-dweb';
import SeoStaticPagesDweb from '../containers/seo-static-pages/seo-static-page-dweb';
import SeoInternationalDweb from '../containers/seo-international/seo-international-dweb';

export default [
  {
    path: ['/flights/:srcCity-to-:destCity-:airline-airline-schedule/'],
    component: SrpSeoDweb,
    key: 'SrpSeoDwebDomAirlineSchedule',
    exact: true,
    inServerInit: () => {},
    showHeader: true,
    showFooter: false,
    toBeSSRed: true,
    directLanding: true,
    populateStoreFromUrl: populateStoreSeoSrpAirlineSchedule,
    fillStoreOnServer: fillStoreSrp,
    fillStoreWaitTime: 100000,
    getRedirectPath: getRedirectPath
  },
  {
    path: ['/flights/hi/:srcCity-to-:destCity-:airline-airline-schedule/'],
    component: SrpSeoDweb,
    key: 'SrpSeoDwebHiDomAirlineSchedule',
    exact: true,
    inServerInit: () => {},
    showHeader: true,
    showFooter: false,
    toBeSSRed: true,
    directLanding: true,
    populateStoreFromUrl: populateStoreSeoSrpHiAirlineSchedule,
    fillStoreOnServer: fillStoreSrp,
    fillStoreWaitTime: 100000,
    getRedirectPath: getRedirectPath
  },
  {
    path: ['/flights/:srcCity-to-:destCity-flights/'],
    component: SrpSeoDweb,
    key: 'SrpSeoDwebDomRoute',
    exact: true,
    inServerInit: () => {},
    showHeader: true,
    showFooter: false,
    toBeSSRed: true,
    directLanding: true,
    populateStoreFromUrl: populateStoreSeoSrpFlights,
    fillStoreOnServer: fillStoreSrp,
    fillStoreWaitTime: 100000,
    toBeCached: true,
    getRedirectPath: getRedirectPath,
    cacheConfig: {
      getCacheKey: ({ params }) => {
        return `dflt-seo-srp_${params.srcCity}-${params.destCity}_route`;
      },
      aerospikeConfig: ({ params }) => {
        // for local aerospike setup
        // https://medium.com/@nikhilajayk/quick-setup-guide-aerospike-on-windows-in-minutes-using-docker-b45840f8ce2c
        // docker run -tid --name aerospike -p 3000:3000 -p 3001:3001 -p 3002:3002 -p 3003:3003 aerospike/aerospike-server
        const obj = {
          ip: aerospikeIp,
          port: aerospikePort,
          namespace: aerospikeNamespaceForFlights,
          set: 'flights-seo-srp',
          ttl: 60 * 60 * 24 * 365 // 365 days
        };
        return obj;
      }
    }
  },
  {
    path: ['/flights/:srcCity-to-:destCity-distance/'],
    component: SrpSeoDweb,
    key: 'SrpSeoDwebDistance',
    exact: true,
    inServerInit: () => {},
    showHeader: true,
    showFooter: false,
    toBeSSRed: true,
    directLanding: true,
    populateStoreFromUrl: populateStoreSeoSrpDistance,
    fillStoreOnServer: fillStoreSrp,
    fillStoreWaitTime: 100000,
    toBeCached: true,
    getRedirectPath: getRedirectPath,
    cacheConfig: {
      getCacheKey: ({ params }) => {
        return `dflt-seo-srp_${params.srcCity}-${params.destCity}_distance`;
      },
      aerospikeConfig: ({ params }) => {
        const obj = {
          ip: aerospikeIp,
          port: aerospikePort,
          namespace: aerospikeNamespaceForFlights,
          set: 'flights-seo-srp',
          ttl: 60 * 60 * 24 * 365 // 365 days
        };
        return obj;
      }
    }
  },
  {
    path: ['/flights/hi/:srcCity-to-:destCity-flights'],
    component: SrpSeoDweb,
    key: 'SrpSeoDwebHiDomRoute',
    exact: true,
    inServerInit: () => {},
    showHeader: true,
    showFooter: false,
    toBeSSRed: true,
    directLanding: true,
    populateStoreFromUrl: populateStoreSeoSrpHiFlights,
    fillStoreOnServer: fillStoreSrp,
    fillStoreWaitTime: 100000,
    getRedirectPath: getRedirectPath
  },
  {
    path: ['/flights/:srcCity-to-:destCity-flight-schedule/'],
    component: SrpSeoDweb,
    key: 'SrpSeoDwebDomFlightSchedule',
    exact: true,
    inServerInit: () => {},
    showHeader: true,
    showFooter: false,
    toBeSSRed: true,
    directLanding: true,
    populateStoreFromUrl: populateStoreSeoSrpFlightSchedule,
    fillStoreOnServer: fillStoreSrp,
    fillStoreWaitTime: 100000,
    getRedirectPath: getRedirectPath
  },
  {
    path: ['/flights/hi/:srcCity-to-:destCity-flight-schedule/'],
    component: SrpSeoDweb,
    key: 'SrpSeoDwebHiDomFlightSchedule',
    exact: true,
    inServerInit: () => {},
    showHeader: true,
    showFooter: false,
    toBeSSRed: true,
    directLanding: true,
    populateStoreFromUrl: populateStoreSeoSrpHiFlightSchedule,
    fillStoreOnServer: fillStoreSrp,
    fillStoreWaitTime: 100000,
    getRedirectPath: getRedirectPath
  },
  {
    path: ['/flights/flights-to-:city/'],
    component: SeoFlightsToFlightsFromDweb,
    key: 'SrpSeoDwebDomFlightsTo',
    exact: true,
    inServerInit: () => {},
    showHeader: true,
    showFooter: false,
    toBeSSRed: true,
    directLanding: true,
    populateStoreFromUrl: populateStoreSeoSrpFlightsTo,
    fillStoreOnServer: fillStoreSeoFlightsToFlightsFrom,
    fillStoreWaitTime: 100000,
    getRedirectPath: getRedirectPath
  },
  {
    path: ['/flights/hi/flights-to-:city/'],
    component: SeoFlightsToFlightsFromDweb,
    key: 'SrpSeoDwebDomHiFlightsTo',
    exact: true,
    inServerInit: () => {},
    showHeader: true,
    showFooter: false,
    toBeSSRed: true,
    directLanding: true,
    populateStoreFromUrl: populateStoreSeoSrpHiFlightsTo,
    fillStoreOnServer: fillStoreSeoFlightsToFlightsFrom,
    fillStoreWaitTime: 100000,
    getRedirectPath: getRedirectPath
  },
  {
    path: ['/flights/flights-from-:city/'],
    component: SeoFlightsToFlightsFromDweb,
    key: 'SrpSeoDwebDomFlightsFrom',
    exact: true,
    inServerInit: () => {},
    showHeader: true,
    showFooter: false,
    toBeSSRed: true,
    directLanding: true,
    populateStoreFromUrl: populateStoreSeoSrpFlightsFrom,
    fillStoreOnServer: fillStoreSeoFlightsToFlightsFrom,
    fillStoreWaitTime: 100000,
    getRedirectPath: getRedirectPath
  },
  {
    path: ['/flights/hi/flights-from-:city/'],
    component: SeoFlightsToFlightsFromDweb,
    key: 'SrpSeoDwebDomHiFlightsFrom',
    exact: true,
    inServerInit: () => {},
    showHeader: true,
    showFooter: false,
    toBeSSRed: true,
    directLanding: true,
    populateStoreFromUrl: populateStoreSeoSrpHiFlightsFrom,
    fillStoreOnServer: fillStoreSeoFlightsToFlightsFrom,
    fillStoreWaitTime: 100000,
    getRedirectPath: getRedirectPath
  },
  {
    path: ['/airlines/:airline/'],
    component: SeoAirlinesDweb,
    key: 'SeoAirlinesDweb',
    exact: true,
    inServerInit: () => {},
    showHeader: true,
    showFooter: false,
    toBeSSRed: true,
    directLanding: true,
    populateStoreFromUrl: populateStoreSeoSrpAirlines,
    fillStoreOnServer: fillStoreSeoAirlines,
    fillStoreWaitTime: 100000
  },
  {
    path: ['/flights/cheap-flights'],
    component: SeoCheapFlightsDweb,
    key: 'SeoCheapFlightsDweb',
    exact: true,
    inServerInit: () => {},
    showHeader: true,
    showFooter: false,
    toBeSSRed: true,
    directLanding: true,
    populateStoreFromUrl: populateStoreSeoSrpCheapFlights,
    fillStoreOnServer: fillStoreSeoCheapFlightsFlightSchedule,
    fillStoreWaitTime: 100000
  },
  {
    path: ['/flight-schedule/'],
    component: SeoFlightScheduleDweb,
    key: 'SeoFlightScheduleDweb',
    exact: true,
    inServerInit: () => {},
    showHeader: true,
    showFooter: false,
    toBeSSRed: true,
    directLanding: true,
    populateStoreFromUrl: populateStoreSeoFlightSchedule,
    fillStoreOnServer: fillStoreSeoCheapFlightsFlightSchedule,
    fillStoreWaitTime: 100000
  },
  {
    path: [
      '/international-flights/:srcCity-to-:destCity-flights/',
      '/international-flights/:country-cnt-:countryId/:srcCity-to-:destCity-flights/'
    ],
    component: SeoInternationalDweb,
    key: 'SrpSeoDwebIntRoute',
    exact: true,
    inServerInit: () => {},
    showHeader: true,
    showFooter: false,
    toBeSSRed: true,
    directLanding: true,
    populateStoreFromUrl: populateStoreSeoSrpInternationalFlights,
    fillStoreOnServer: fillStoreSeoInternationalFlights,
    fillStoreWaitTime: 100000,
    toBeCached: true,
    getRedirectPath: getRedirectPath,
    cacheConfig: {
      getCacheKey: ({ params }) => {
        const countryCacheKey = params.country && params.countryId ? params.countryId : '';
        return `dflt-intl-seo-srp_${params.srcCity}-${params.destCity}${
          countryCacheKey ? `-${countryCacheKey}` : ''
        }_route`;
      },
      aerospikeConfig: ({ params }) => {
        // for local aerospike setup
        // https://medium.com/@nikhilajayk/quick-setup-guide-aerospike-on-windows-in-minutes-using-docker-b45840f8ce2c
        // docker run -tid --name aerospike -p 3000:3000 -p 3001:3001 -p 3002:3002 -p 3003:3003 aerospike/aerospike-server
        const obj = {
          ip: aerospikeIp,
          port: aerospikePort,
          namespace: aerospikeNamespaceForFlights,
          set: 'flights-seo-srp',
          ttl: 60 * 60 * 24 * 365 // 365 days
        };
        return obj;
      }
    }
  },
  {
    path: ['/international-flights/hi/:srcCity-to-:destCity-flights/'],
    component: SrpSeoDweb,
    key: 'SrpSeoDwebHiIntRoute',
    exact: true,
    inServerInit: () => {},
    showHeader: true,
    showFooter: false,
    toBeSSRed: true,
    directLanding: true,
    populateStoreFromUrl: populateStoreSeoSrpHiInternationalFlights,
    fillStoreOnServer: fillStoreSrp,
    fillStoreWaitTime: 100000,
    getRedirectPath: getRedirectPath
  },
  {
    path: [
      '/international-flights/:srcCity-to-:destCity-flight-schedule/',
      '/international-flights/:country-cnt-:countryId/:srcCity-to-:destCity-flight-schedule/'
    ],
    component: SrpSeoDweb,
    key: 'SrpSeoDwebIntFlightSchedule',
    exact: true,
    inServerInit: () => {},
    showHeader: true,
    showFooter: false,
    toBeSSRed: true,
    directLanding: true,
    populateStoreFromUrl: populateStoreSeoSrpInternationalFlightSchedule,
    fillStoreOnServer: fillStoreSrp,
    fillStoreWaitTime: 100000,
    toBeCached: true,
    getRedirectPath: getRedirectPath,
    cacheConfig: {
      getCacheKey: ({ params }) => {
        const countryCacheKey = params.country && params.countryId ? params.countryId : '';
        return `dflt-intl-seo-srp_${params.srcCity}-${params.destCity}${
          countryCacheKey ? `-${countryCacheKey}` : ''
        }_flight_schedule`;
      },
      aerospikeConfig: ({ params }) => {
        // for local aerospike setup
        // https://medium.com/@nikhilajayk/quick-setup-guide-aerospike-on-windows-in-minutes-using-docker-b45840f8ce2c
        // docker run -tid --name aerospike -p 3000:3000 -p 3001:3001 -p 3002:3002 -p 3003:3003 aerospike/aerospike-server
        const obj = {
          ip: aerospikeIp,
          port: aerospikePort,
          namespace: aerospikeNamespaceForFlights,
          set: 'flights-seo-srp',
          ttl: 60 * 60 * 24 * 365 // 365 days
        };
        return obj;
      }
    }
  },
  {
    path: ['/international-flights/hi/:srcCity-to-:destCity-flight-schedule/'],
    component: SrpSeoDweb,
    key: 'SrpSeoDwebIntHiFlightSchedule',
    exact: true,
    inServerInit: () => {},
    showHeader: true,
    showFooter: false,
    toBeSSRed: true,
    directLanding: true,
    populateStoreFromUrl: populateStoreSeoSrpHiInternationalFlightSchedule,
    fillStoreOnServer: fillStoreSrp,
    fillStoreWaitTime: 100000,
    getRedirectPath: getRedirectPath
  },
  {
    path: ['/international-flights/:srcCity-to-:destCity-:airline-airline-schedule/'],
    component: SrpSeoDweb,
    key: 'SrpSeoDwebIntAirlineSchedule',
    exact: true,
    inServerInit: () => {},
    showHeader: true,
    showFooter: false,
    toBeSSRed: true,
    directLanding: true,
    populateStoreFromUrl: populateStoreSeoSrpInternationalAirlineSchedule,
    fillStoreOnServer: fillStoreSrp,
    fillStoreWaitTime: 100000,
    toBeCached: true,
    getRedirectPath: getRedirectPath,
    cacheConfig: {
      getCacheKey: ({ params }) => {
        return `dflt-intl-seo-srp_${params.srcCity}-${params.destCity}-${params.airline}_route`;
      },
      aerospikeConfig: ({ params }) => {
        // for local aerospike setup
        // https://medium.com/@nikhilajayk/quick-setup-guide-aerospike-on-windows-in-minutes-using-docker-b45840f8ce2c
        // docker run -tid --name aerospike -p 3000:3000 -p 3001:3001 -p 3002:3002 -p 3003:3003 aerospike/aerospike-server
        const obj = {
          ip: aerospikeIp,
          port: aerospikePort,
          namespace: aerospikeNamespaceForFlights,
          set: 'flights-seo-srp',
          ttl: 60 * 60 * 24 * 365 // 365 days
        };
        return obj;
      }
    }
  },
  {
    path: ['/international-flights/hi/:srcCity-to-:destCity-:airline-airline-schedule/'],
    component: SrpSeoDweb,
    key: 'SrpSeoDwebIntHiAirlineSchedule',
    exact: true,
    inServerInit: () => {},
    showHeader: true,
    showFooter: false,
    toBeSSRed: true,
    directLanding: true,
    populateStoreFromUrl: populateStoreSeoSrpHiInternationalAirlineSchedule,
    fillStoreOnServer: fillStoreSrp,
    fillStoreWaitTime: 100000,
    toBeCached: true,
    getRedirectPath: getRedirectPath
  },
  {
    path: ['/international-flights/flights-to-:city/'],
    component: SeoFlightsToFlightsFromDweb,
    key: 'SrpSeoDwebIntFlightsTo',
    exact: true,
    inServerInit: () => {},
    showHeader: true,
    showFooter: false,
    toBeSSRed: true,
    directLanding: true,
    populateStoreFromUrl: populateStoreSeoIntlFlightsTo,
    fillStoreOnServer: fillStoreSeoFlightsToFlightsFrom,
    fillStoreWaitTime: 100000,
    toBeCached: true,
    getRedirectPath: getRedirectPath,
    cacheConfig: {
      getCacheKey: ({ params }) => {
        return `dflt-intl-seo_${params.city}_flights_to`;
      },
      aerospikeConfig: ({ params }) => {
        // for local aerospike setup
        // https://medium.com/@nikhilajayk/quick-setup-guide-aerospike-on-windows-in-minutes-using-docker-b45840f8ce2c
        // docker run -tid --name aerospike -p 3000:3000 -p 3001:3001 -p 3002:3002 -p 3003:3003 aerospike/aerospike-server
        const obj = {
          ip: aerospikeIp,
          port: aerospikePort,
          namespace: aerospikeNamespaceForFlights,
          set: 'flights-seo-srp',
          ttl: 60 * 60 * 24 * 365 // 365 days
        };
        return obj;
      }
    }
  },
  {
    path: ['/international-flights/hi/flights-to-:city/'],
    component: SeoFlightsToFlightsFromDweb,
    key: 'SrpSeoDwebIntHiFlightsTo',
    exact: true,
    inServerInit: () => {},
    showHeader: true,
    showFooter: false,
    toBeSSRed: true,
    directLanding: true,
    populateStoreFromUrl: populateStoreSeoHiIntlFlightsTo,
    fillStoreOnServer: fillStoreSeoFlightsToFlightsFrom,
    fillStoreWaitTime: 100000,
    toBeCached: true,
    getRedirectPath: getRedirectPath
  },
  {
    path: ['/international-flights/flights-from-:city/'],
    component: SeoFlightsToFlightsFromDweb,
    key: 'SrpSeoDwebIntFlightsFrom',
    exact: true,
    inServerInit: () => {},
    showHeader: true,
    showFooter: false,
    toBeSSRed: true,
    directLanding: true,
    populateStoreFromUrl: populateStoreSeoIntlFlightsFrom,
    fillStoreOnServer: fillStoreSeoFlightsToFlightsFrom,
    fillStoreWaitTime: 100000,
    getRedirectPath: getRedirectPath
  },
  {
    path: ['/international-flights/hi/flights-from-:city/'],
    component: SeoFlightsToFlightsFromDweb,
    key: 'SrpSeoDwebIntHiFlightsFrom',
    exact: true,
    inServerInit: () => {},
    showHeader: true,
    showFooter: false,
    toBeSSRed: true,
    directLanding: true,
    populateStoreFromUrl: populateStoreSeoHiIntlFlightsFrom,
    fillStoreOnServer: fillStoreSeoFlightsToFlightsFrom,
    fillStoreWaitTime: 100000,
    getRedirectPath: getRedirectPath
  },
  {
    path: ['/flights/:staticPageName.htm'],
    component: SeoStaticPagesDweb,
    key: 'SeoStaticPagesDweb',
    exact: true,
    inServerInit: () => {},
    showHeader: true,
    showFooter: false,
    toBeSSRed: true,
    directLanding: true,
    populateStoreFromUrl: populateStoreSeoStaticPages,
    fillStoreOnServer: fillStoreSeoStaticPages,
    fillStoreWaitTime: 100000
  },
  {
    path: ['/flights/sitemap.xml'],
    component: '',
    key: '',
    exact: true,
    inServerInit: () => {},
    showHeader: false,
    showFooter: false,
    toBeSSRed: true,
    directLanding: true,
    contentType: 'text/xml',
    toBeCached: true,
    cacheConfig: {
      getCacheKey: ({ params }) => {
        return `df-index-sitemap`;
      },
      aerospikeConfig: ({ params }) => {
        // for local aerospike setup
        // https://medium.com/@nikhilajayk/quick-setup-guide-aerospike-on-windows-in-minutes-using-docker-b45840f8ce2c
        // docker run -tid --name aerospike -p 3000:3000 -p 3001:3001 -p 3002:3002 -p 3003:3003 aerospike/aerospike-server
        const obj = {
          ip: aerospikeIp,
          port: aerospikePort,
          namespace: aerospikeNamespaceForFlights,
          set: 'flights-seo-srp',
          ttl: 60 * 60 * 24 * 365 // 365 days
        };
        return obj;
      }
    }
  },
  {
    path: ['/flights/sitemap/static-pages-sitemap-:sitemapIndex.xml'],
    component: '',
    key: '',
    exact: true,
    inServerInit: () => {},
    showHeader: false,
    showFooter: false,
    toBeSSRed: true,
    directLanding: true,
    contentType: 'text/xml',
    toBeCached: true,
    cacheConfig: {
      getCacheKey: ({ params }) => {
        return `df-static-pages-sitemap-${params.sitemapIndex}`;
      },
      aerospikeConfig: ({ params }) => {
        // for local aerospike setup
        // https://medium.com/@nikhilajayk/quick-setup-guide-aerospike-on-windows-in-minutes-using-docker-b45840f8ce2c
        // docker run -tid --name aerospike -p 3000:3000 -p 3001:3001 -p 3002:3002 -p 3003:3003 aerospike/aerospike-server
        const obj = {
          ip: aerospikeIp,
          port: aerospikePort,
          namespace: aerospikeNamespaceForFlights,
          set: 'flights-seo-srp',
          ttl: 60 * 60 * 24 * 365 // 365 days
        };
        return obj;
      }
    }
  },
  {
    path: ['/flights/sitemap/df-flights-to-sitemap-:sitemapIndex.xml'],
    component: '',
    key: '',
    exact: true,
    inServerInit: () => {},
    showHeader: false,
    showFooter: false,
    toBeSSRed: true,
    directLanding: true,
    contentType: 'text/xml',
    toBeCached: true,
    cacheConfig: {
      getCacheKey: ({ params }) => {
        return `df-flights-to-sitemap-${params.sitemapIndex}`;
      },
      aerospikeConfig: ({ params }) => {
        // for local aerospike setup
        // https://medium.com/@nikhilajayk/quick-setup-guide-aerospike-on-windows-in-minutes-using-docker-b45840f8ce2c
        // docker run -tid --name aerospike -p 3000:3000 -p 3001:3001 -p 3002:3002 -p 3003:3003 aerospike/aerospike-server
        const obj = {
          ip: aerospikeIp,
          port: aerospikePort,
          namespace: aerospikeNamespaceForFlights,
          set: 'flights-seo-srp',
          ttl: 60 * 60 * 24 * 365 // 365 days
        };
        return obj;
      }
    }
  },
  {
    path: ['/flights/sitemap/df-flights-from-sitemap-:sitemapIndex.xml'],
    component: '',
    key: '',
    exact: true,
    inServerInit: () => {},
    showHeader: false,
    showFooter: false,
    toBeSSRed: true,
    directLanding: true,
    contentType: 'text/xml',
    toBeCached: true,
    cacheConfig: {
      getCacheKey: ({ params }) => {
        return `df-flights-from-sitemap-${params.sitemapIndex}`;
      },
      aerospikeConfig: ({ params }) => {
        // for local aerospike setup
        // https://medium.com/@nikhilajayk/quick-setup-guide-aerospike-on-windows-in-minutes-using-docker-b45840f8ce2c
        // docker run -tid --name aerospike -p 3000:3000 -p 3001:3001 -p 3002:3002 -p 3003:3003 aerospike/aerospike-server
        const obj = {
          ip: aerospikeIp,
          port: aerospikePort,
          namespace: aerospikeNamespaceForFlights,
          set: 'flights-seo-srp',
          ttl: 60 * 60 * 24 * 365 // 365 days
        };
        return obj;
      }
    }
  },
  {
    path: ['/flights/sitemap/airlines-sitemap-:sitemapIndex.xml'],
    component: '',
    key: '',
    exact: true,
    inServerInit: () => {},
    showHeader: false,
    showFooter: false,
    toBeSSRed: true,
    directLanding: true,
    contentType: 'text/xml',
    toBeCached: true,
    cacheConfig: {
      getCacheKey: ({ params }) => {
        return `airlines-sitemap-${params.sitemapIndex}`;
      },
      aerospikeConfig: ({ params }) => {
        // for local aerospike setup
        // https://medium.com/@nikhilajayk/quick-setup-guide-aerospike-on-windows-in-minutes-using-docker-b45840f8ce2c
        // docker run -tid --name aerospike -p 3000:3000 -p 3001:3001 -p 3002:3002 -p 3003:3003 aerospike/aerospike-server
        const obj = {
          ip: aerospikeIp,
          port: aerospikePort,
          namespace: aerospikeNamespaceForFlights,
          set: 'flights-seo-srp',
          ttl: 60 * 60 * 24 * 365 // 365 days
        };
        return obj;
      }
    }
  },
  {
    path: ['/flights/sitemap/df-route-sitemap-:sitemapIndex.xml'],
    component: '',
    key: '',
    exact: true,
    inServerInit: () => {},
    showHeader: false,
    showFooter: false,
    toBeSSRed: true,
    directLanding: true,
    contentType: 'text/xml',
    toBeCached: true,
    cacheConfig: {
      getCacheKey: ({ params }) => {
        return `df-route-sitemap-${params.sitemapIndex}`;
      },
      aerospikeConfig: ({ params }) => {
        // for local aerospike setup
        // https://medium.com/@nikhilajayk/quick-setup-guide-aerospike-on-windows-in-minutes-using-docker-b45840f8ce2c
        // docker run -tid --name aerospike -p 3000:3000 -p 3001:3001 -p 3002:3002 -p 3003:3003 aerospike/aerospike-server
        const obj = {
          ip: aerospikeIp,
          port: aerospikePort,
          namespace: aerospikeNamespaceForFlights,
          set: 'flights-seo-srp',
          ttl: 60 * 60 * 24 * 365 // 365 days
        };
        return obj;
      }
    }
  },
  {
    path: ['/flights/sitemap/df-distance-sitemap-:sitemapIndex.xml'],
    component: '',
    key: '',
    exact: true,
    inServerInit: () => {},
    showHeader: false,
    showFooter: false,
    toBeSSRed: true,
    directLanding: true,
    contentType: 'text/xml',
    toBeCached: true,
    cacheConfig: {
      getCacheKey: ({ params }) => {
        return `df-distance-sitemap-${params.sitemapIndex}`;
      },
      aerospikeConfig: ({ params }) => {
        // for local aerospike setup
        // https://medium.com/@nikhilajayk/quick-setup-guide-aerospike-on-windows-in-minutes-using-docker-b45840f8ce2c
        // docker run -tid --name aerospike -p 3000:3000 -p 3001:3001 -p 3002:3002 -p 3003:3003 aerospike/aerospike-server
        const obj = {
          ip: aerospikeIp,
          port: aerospikePort,
          namespace: aerospikeNamespaceForFlights,
          set: 'flights-seo-srp',
          ttl: 60 * 60 * 24 * 365 // 365 days
        };
        return obj;
      }
    }
  },
  {
    path: ['/flights/sitemap/df-flight-schedule-sitemap-:sitemapIndex.xml'],
    component: '',
    key: '',
    exact: true,
    inServerInit: () => {},
    showHeader: false,
    showFooter: false,
    toBeSSRed: true,
    directLanding: true,
    contentType: 'text/xml',
    toBeCached: true,
    cacheConfig: {
      getCacheKey: ({ params }) => {
        return `df-flight-schedule-sitemap-${params.sitemapIndex}`;
      },
      aerospikeConfig: ({ params }) => {
        // for local aerospike setup
        // https://medium.com/@nikhilajayk/quick-setup-guide-aerospike-on-windows-in-minutes-using-docker-b45840f8ce2c
        // docker run -tid --name aerospike -p 3000:3000 -p 3001:3001 -p 3002:3002 -p 3003:3003 aerospike/aerospike-server
        const obj = {
          ip: aerospikeIp,
          port: aerospikePort,
          namespace: aerospikeNamespaceForFlights,
          set: 'flights-seo-srp',
          ttl: 60 * 60 * 24 * 365 // 365 days
        };
        return obj;
      }
    }
  },
  {
    path: ['/flights/sitemap/df-airline-schedule-sitemap-:sitemapIndex.xml'],
    component: '',
    key: '',
    exact: true,
    inServerInit: () => {},
    showHeader: false,
    showFooter: false,
    toBeSSRed: true,
    directLanding: true,
    contentType: 'text/xml',
    toBeCached: true,
    cacheConfig: {
      getCacheKey: ({ params }) => {
        return `df-airline-schedule-sitemap-${params.sitemapIndex}`;
      },
      aerospikeConfig: ({ params }) => {
        // for local aerospike setup
        // https://medium.com/@nikhilajayk/quick-setup-guide-aerospike-on-windows-in-minutes-using-docker-b45840f8ce2c
        // docker run -tid --name aerospike -p 3000:3000 -p 3001:3001 -p 3002:3002 -p 3003:3003 aerospike/aerospike-server
        const obj = {
          ip: aerospikeIp,
          port: aerospikePort,
          namespace: aerospikeNamespaceForFlights,
          set: 'flights-seo-srp',
          ttl: 60 * 60 * 24 * 365 // 365 days
        };
        return obj;
      }
    }
  },
  {
    path: ['/flights/hi/sitemap.xml'],
    component: '',
    key: '',
    exact: true,
    inServerInit: () => {},
    showHeader: false,
    showFooter: false,
    toBeSSRed: true,
    directLanding: true,
    contentType: 'text/xml',
    toBeCached: true,
    cacheConfig: {
      getCacheKey: ({ params }) => {
        return `df-hi-index-sitemap`;
      },
      aerospikeConfig: ({ params }) => {
        // for local aerospike setup
        // https://medium.com/@nikhilajayk/quick-setup-guide-aerospike-on-windows-in-minutes-using-docker-b45840f8ce2c
        // docker run -tid --name aerospike -p 3000:3000 -p 3001:3001 -p 3002:3002 -p 3003:3003 aerospike/aerospike-server
        const obj = {
          ip: aerospikeIp,
          port: aerospikePort,
          namespace: aerospikeNamespaceForFlights,
          set: 'flights-seo-srp',
          ttl: 60 * 60 * 24 * 365 // 365 days
        };
        return obj;
      }
    }
  },
  {
    path: ['/flights/hi/sitemap/df-flights-to-sitemap-:sitemapIndex.xml'],
    component: '',
    key: '',
    exact: true,
    inServerInit: () => {},
    showHeader: false,
    showFooter: false,
    toBeSSRed: true,
    directLanding: true,
    contentType: 'text/xml',
    toBeCached: true,
    cacheConfig: {
      getCacheKey: ({ params }) => {
        return `df-hi-flights-to-sitemap-${params.sitemapIndex}`;
      },
      aerospikeConfig: ({ params }) => {
        // for local aerospike setup
        // https://medium.com/@nikhilajayk/quick-setup-guide-aerospike-on-windows-in-minutes-using-docker-b45840f8ce2c
        // docker run -tid --name aerospike -p 3000:3000 -p 3001:3001 -p 3002:3002 -p 3003:3003 aerospike/aerospike-server
        const obj = {
          ip: aerospikeIp,
          port: aerospikePort,
          namespace: aerospikeNamespaceForFlights,
          set: 'flights-seo-srp',
          ttl: 60 * 60 * 24 * 365 // 365 days
        };
        return obj;
      }
    }
  },
  {
    path: ['/flights/hi/sitemap/df-flights-from-sitemap-:sitemapIndex.xml'],
    component: '',
    key: '',
    exact: true,
    inServerInit: () => {},
    showHeader: false,
    showFooter: false,
    toBeSSRed: true,
    directLanding: true,
    contentType: 'text/xml',
    toBeCached: true,
    cacheConfig: {
      getCacheKey: ({ params }) => {
        return `df-hi-flights-from-sitemap-${params.sitemapIndex}`;
      },
      aerospikeConfig: ({ params }) => {
        // for local aerospike setup
        // https://medium.com/@nikhilajayk/quick-setup-guide-aerospike-on-windows-in-minutes-using-docker-b45840f8ce2c
        // docker run -tid --name aerospike -p 3000:3000 -p 3001:3001 -p 3002:3002 -p 3003:3003 aerospike/aerospike-server
        const obj = {
          ip: aerospikeIp,
          port: aerospikePort,
          namespace: aerospikeNamespaceForFlights,
          set: 'flights-seo-srp',
          ttl: 60 * 60 * 24 * 365 // 365 days
        };
        return obj;
      }
    }
  },
  {
    path: ['/flights/hi/sitemap/df-route-sitemap-:sitemapIndex.xml'],
    component: '',
    key: '',
    exact: true,
    inServerInit: () => {},
    showHeader: false,
    showFooter: false,
    toBeSSRed: true,
    directLanding: true,
    contentType: 'text/xml',
    toBeCached: true,
    cacheConfig: {
      getCacheKey: ({ params }) => {
        return `df-hi-route-sitemap-${params.sitemapIndex}`;
      },
      aerospikeConfig: ({ params }) => {
        // for local aerospike setup
        // https://medium.com/@nikhilajayk/quick-setup-guide-aerospike-on-windows-in-minutes-using-docker-b45840f8ce2c
        // docker run -tid --name aerospike -p 3000:3000 -p 3001:3001 -p 3002:3002 -p 3003:3003 aerospike/aerospike-server
        const obj = {
          ip: aerospikeIp,
          port: aerospikePort,
          namespace: aerospikeNamespaceForFlights,
          set: 'flights-seo-srp',
          ttl: 60 * 60 * 24 * 365 // 365 days
        };
        return obj;
      }
    }
  },
  {
    path: ['/flights/hi/sitemap/df-flight-schedule-sitemap-:sitemapIndex.xml'],
    component: '',
    key: '',
    exact: true,
    inServerInit: () => {},
    showHeader: false,
    showFooter: false,
    toBeSSRed: true,
    directLanding: true,
    contentType: 'text/xml',
    toBeCached: true,
    cacheConfig: {
      getCacheKey: ({ params }) => {
        return `df-hi-flight-schedule-sitemap-${params.sitemapIndex}`;
      },
      aerospikeConfig: ({ params }) => {
        // for local aerospike setup
        // https://medium.com/@nikhilajayk/quick-setup-guide-aerospike-on-windows-in-minutes-using-docker-b45840f8ce2c
        // docker run -tid --name aerospike -p 3000:3000 -p 3001:3001 -p 3002:3002 -p 3003:3003 aerospike/aerospike-server
        const obj = {
          ip: aerospikeIp,
          port: aerospikePort,
          namespace: aerospikeNamespaceForFlights,
          set: 'flights-seo-srp',
          ttl: 60 * 60 * 24 * 365 // 365 days
        };
        return obj;
      }
    }
  },
  {
    path: ['/flights/hi/sitemap/df-airline-schedule-sitemap-:sitemapIndex.xml'],
    component: '',
    key: '',
    exact: true,
    inServerInit: () => {},
    showHeader: false,
    showFooter: false,
    toBeSSRed: true,
    directLanding: true,
    contentType: 'text/xml',
    toBeCached: true,
    cacheConfig: {
      getCacheKey: ({ params }) => {
        return `df-hi-airline-schedule-sitemap-${params.sitemapIndex}`;
      },
      aerospikeConfig: ({ params }) => {
        // for local aerospike setup
        // https://medium.com/@nikhilajayk/quick-setup-guide-aerospike-on-windows-in-minutes-using-docker-b45840f8ce2c
        // docker run -tid --name aerospike -p 3000:3000 -p 3001:3001 -p 3002:3002 -p 3003:3003 aerospike/aerospike-server
        const obj = {
          ip: aerospikeIp,
          port: aerospikePort,
          namespace: aerospikeNamespaceForFlights,
          set: 'flights-seo-srp',
          ttl: 60 * 60 * 24 * 365 // 365 days
        };
        return obj;
      }
    }
  },
  {
    path: ['/international-flights/sitemap.xml'],
    component: '',
    key: '',
    exact: true,
    inServerInit: () => {},
    showHeader: false,
    showFooter: false,
    toBeSSRed: true,
    directLanding: true,
    contentType: 'text/xml',
    toBeCached: true,
    cacheConfig: {
      getCacheKey: ({ params }) => {
        return `if-index-sitemap`;
      },
      aerospikeConfig: ({ params }) => {
        // for local aerospike setup
        // https://medium.com/@nikhilajayk/quick-setup-guide-aerospike-on-windows-in-minutes-using-docker-b45840f8ce2c
        // docker run -tid --name aerospike -p 3000:3000 -p 3001:3001 -p 3002:3002 -p 3003:3003 aerospike/aerospike-server
        const obj = {
          ip: aerospikeIp,
          port: aerospikePort,
          namespace: aerospikeNamespaceForFlights,
          set: 'flights-seo-srp',
          ttl: 60 * 60 * 24 * 365 // 365 days
        };
        return obj;
      }
    }
  },
  {
    path: ['/international-flights/sitemap/if-flights-to-sitemap-:sitemapIndex.xml'],
    component: '',
    key: '',
    exact: true,
    inServerInit: () => {},
    showHeader: false,
    showFooter: false,
    toBeSSRed: true,
    directLanding: true,
    contentType: 'text/xml',
    toBeCached: true,
    cacheConfig: {
      getCacheKey: ({ params }) => {
        return `if-flights-to-sitemap-${params.sitemapIndex}`;
      },
      aerospikeConfig: ({ params }) => {
        // for local aerospike setup
        // https://medium.com/@nikhilajayk/quick-setup-guide-aerospike-on-windows-in-minutes-using-docker-b45840f8ce2c
        // docker run -tid --name aerospike -p 3000:3000 -p 3001:3001 -p 3002:3002 -p 3003:3003 aerospike/aerospike-server
        const obj = {
          ip: aerospikeIp,
          port: aerospikePort,
          namespace: aerospikeNamespaceForFlights,
          set: 'flights-seo-srp',
          ttl: 60 * 60 * 24 * 365 // 365 days
        };
        return obj;
      }
    }
  },
  {
    path: ['/international-flights/sitemap/if-flights-from-sitemap-:sitemapIndex.xml'],
    component: '',
    key: '',
    exact: true,
    inServerInit: () => {},
    showHeader: false,
    showFooter: false,
    toBeSSRed: true,
    directLanding: true,
    contentType: 'text/xml',
    toBeCached: true,
    cacheConfig: {
      getCacheKey: ({ params }) => {
        return `if-flights-from-sitemap-${params.sitemapIndex}`;
      },
      aerospikeConfig: ({ params }) => {
        // for local aerospike setup
        // https://medium.com/@nikhilajayk/quick-setup-guide-aerospike-on-windows-in-minutes-using-docker-b45840f8ce2c
        // docker run -tid --name aerospike -p 3000:3000 -p 3001:3001 -p 3002:3002 -p 3003:3003 aerospike/aerospike-server
        const obj = {
          ip: aerospikeIp,
          port: aerospikePort,
          namespace: aerospikeNamespaceForFlights,
          set: 'flights-seo-srp',
          ttl: 60 * 60 * 24 * 365 // 365 days
        };
        return obj;
      }
    }
  },
  {
    path: ['/international-flights/sitemap/airlines-sitemap-:sitemapIndex.xml'],
    component: '',
    key: '',
    exact: true,
    inServerInit: () => {},
    showHeader: false,
    showFooter: false,
    toBeSSRed: true,
    directLanding: true,
    contentType: 'text/xml',
    toBeCached: true,
    cacheConfig: {
      getCacheKey: ({ params }) => {
        return `if-airlines-sitemap-${params.sitemapIndex}`;
      },
      aerospikeConfig: ({ params }) => {
        // for local aerospike setup
        // https://medium.com/@nikhilajayk/quick-setup-guide-aerospike-on-windows-in-minutes-using-docker-b45840f8ce2c
        // docker run -tid --name aerospike -p 3000:3000 -p 3001:3001 -p 3002:3002 -p 3003:3003 aerospike/aerospike-server
        const obj = {
          ip: aerospikeIp,
          port: aerospikePort,
          namespace: aerospikeNamespaceForFlights,
          set: 'flights-seo-srp',
          ttl: 60 * 60 * 24 * 365 // 365 days
        };
        return obj;
      }
    }
  },
  {
    path: ['/international-flights/sitemap/if-route-sitemap-:sitemapIndex.xml'],
    component: '',
    key: '',
    exact: true,
    inServerInit: () => {},
    showHeader: false,
    showFooter: false,
    toBeSSRed: true,
    directLanding: true,
    contentType: 'text/xml',
    toBeCached: true,
    cacheConfig: {
      getCacheKey: ({ params }) => {
        return `if-route-sitemap-${params.sitemapIndex}`;
      },
      aerospikeConfig: ({ params }) => {
        // for local aerospike setup
        // https://medium.com/@nikhilajayk/quick-setup-guide-aerospike-on-windows-in-minutes-using-docker-b45840f8ce2c
        // docker run -tid --name aerospike -p 3000:3000 -p 3001:3001 -p 3002:3002 -p 3003:3003 aerospike/aerospike-server
        const obj = {
          ip: aerospikeIp,
          port: aerospikePort,
          namespace: aerospikeNamespaceForFlights,
          set: 'flights-seo-srp',
          ttl: 60 * 60 * 24 * 365 // 365 days
        };
        return obj;
      }
    }
  },
  {
    path: ['/international-flights/sitemap/if-flight-schedule-sitemap-:sitemapIndex.xml'],
    component: '',
    key: '',
    exact: true,
    inServerInit: () => {},
    showHeader: false,
    showFooter: false,
    toBeSSRed: true,
    directLanding: true,
    contentType: 'text/xml',
    toBeCached: true,
    cacheConfig: {
      getCacheKey: ({ params }) => {
        return `if-flight-schedule-sitemap-${params.sitemapIndex}`;
      },
      aerospikeConfig: ({ params }) => {
        // for local aerospike setup
        // https://medium.com/@nikhilajayk/quick-setup-guide-aerospike-on-windows-in-minutes-using-docker-b45840f8ce2c
        // docker run -tid --name aerospike -p 3000:3000 -p 3001:3001 -p 3002:3002 -p 3003:3003 aerospike/aerospike-server
        const obj = {
          ip: aerospikeIp,
          port: aerospikePort,
          namespace: aerospikeNamespaceForFlights,
          set: 'flights-seo-srp',
          ttl: 60 * 60 * 24 * 365 // 365 days
        };
        return obj;
      }
    }
  },
  {
    path: ['/international-flights/sitemap/if-airline-schedule-sitemap-:sitemapIndex.xml'],
    component: '',
    key: '',
    exact: true,
    inServerInit: () => {},
    showHeader: false,
    showFooter: false,
    toBeSSRed: true,
    directLanding: true,
    contentType: 'text/xml',
    toBeCached: true,
    cacheConfig: {
      getCacheKey: ({ params }) => {
        return `if-airline-schedule-sitemap-${params.sitemapIndex}`;
      },
      aerospikeConfig: ({ params }) => {
        // for local aerospike setup
        // https://medium.com/@nikhilajayk/quick-setup-guide-aerospike-on-windows-in-minutes-using-docker-b45840f8ce2c
        // docker run -tid --name aerospike -p 3000:3000 -p 3001:3001 -p 3002:3002 -p 3003:3003 aerospike/aerospike-server
        const obj = {
          ip: aerospikeIp,
          port: aerospikePort,
          namespace: aerospikeNamespaceForFlights,
          set: 'flights-seo-srp',
          ttl: 60 * 60 * 24 * 365 // 365 days
        };
        return obj;
      }
    }
  },
  {
    path: ['/international-flights/hi/sitemap.xml'],
    component: '',
    key: '',
    exact: true,
    inServerInit: () => {},
    showHeader: false,
    showFooter: false,
    toBeSSRed: true,
    directLanding: true,
    contentType: 'text/xml',
    toBeCached: true,
    cacheConfig: {
      getCacheKey: ({ params }) => {
        return `if-hi-index-sitemap`;
      },
      aerospikeConfig: ({ params }) => {
        // for local aerospike setup
        // https://medium.com/@nikhilajayk/quick-setup-guide-aerospike-on-windows-in-minutes-using-docker-b45840f8ce2c
        // docker run -tid --name aerospike -p 3000:3000 -p 3001:3001 -p 3002:3002 -p 3003:3003 aerospike/aerospike-server
        const obj = {
          ip: aerospikeIp,
          port: aerospikePort,
          namespace: aerospikeNamespaceForFlights,
          set: 'flights-seo-srp',
          ttl: 60 * 60 * 24 * 365 // 365 days
        };
        return obj;
      }
    }
  },
  {
    path: ['/international-flights/hi/sitemap/if-flights-to-sitemap-:sitemapIndex.xml'],
    component: '',
    key: '',
    exact: true,
    inServerInit: () => {},
    showHeader: false,
    showFooter: false,
    toBeSSRed: true,
    directLanding: true,
    contentType: 'text/xml',
    toBeCached: true,
    cacheConfig: {
      getCacheKey: ({ params }) => {
        return `if-hi-flights-to-sitemap-${params.sitemapIndex}`;
      },
      aerospikeConfig: ({ params }) => {
        // for local aerospike setup
        // https://medium.com/@nikhilajayk/quick-setup-guide-aerospike-on-windows-in-minutes-using-docker-b45840f8ce2c
        // docker run -tid --name aerospike -p 3000:3000 -p 3001:3001 -p 3002:3002 -p 3003:3003 aerospike/aerospike-server
        const obj = {
          ip: aerospikeIp,
          port: aerospikePort,
          namespace: aerospikeNamespaceForFlights,
          set: 'flights-seo-srp',
          ttl: 60 * 60 * 24 * 365 // 365 days
        };
        return obj;
      }
    }
  },
  {
    path: ['/international-flights/hi/sitemap/if-flights-from-sitemap-:sitemapIndex.xml'],
    component: '',
    key: '',
    exact: true,
    inServerInit: () => {},
    showHeader: false,
    showFooter: false,
    toBeSSRed: true,
    directLanding: true,
    contentType: 'text/xml',
    toBeCached: true,
    cacheConfig: {
      getCacheKey: ({ params }) => {
        return `if-hi-flights-from-sitemap-${params.sitemapIndex}`;
      },
      aerospikeConfig: ({ params }) => {
        // for local aerospike setup
        // https://medium.com/@nikhilajayk/quick-setup-guide-aerospike-on-windows-in-minutes-using-docker-b45840f8ce2c
        // docker run -tid --name aerospike -p 3000:3000 -p 3001:3001 -p 3002:3002 -p 3003:3003 aerospike/aerospike-server
        const obj = {
          ip: aerospikeIp,
          port: aerospikePort,
          namespace: aerospikeNamespaceForFlights,
          set: 'flights-seo-srp',
          ttl: 60 * 60 * 24 * 365 // 365 days
        };
        return obj;
      }
    }
  },
  {
    path: ['/international-flights/hi/sitemap/if-route-sitemap-:sitemapIndex.xml'],
    component: '',
    key: '',
    exact: true,
    inServerInit: () => {},
    showHeader: false,
    showFooter: false,
    toBeSSRed: true,
    directLanding: true,
    contentType: 'text/xml',
    toBeCached: true,
    cacheConfig: {
      getCacheKey: ({ params }) => {
        return `if-hi-route-sitemap-${params.sitemapIndex}`;
      },
      aerospikeConfig: ({ params }) => {
        // for local aerospike setup
        // https://medium.com/@nikhilajayk/quick-setup-guide-aerospike-on-windows-in-minutes-using-docker-b45840f8ce2c
        // docker run -tid --name aerospike -p 3000:3000 -p 3001:3001 -p 3002:3002 -p 3003:3003 aerospike/aerospike-server
        const obj = {
          ip: aerospikeIp,
          port: aerospikePort,
          namespace: aerospikeNamespaceForFlights,
          set: 'flights-seo-srp',
          ttl: 60 * 60 * 24 * 365 // 365 days
        };
        return obj;
      }
    }
  },
  {
    path: ['/international-flights/hi/sitemap/if-flight-schedule-sitemap-:sitemapIndex.xml'],
    component: '',
    key: '',
    exact: true,
    inServerInit: () => {},
    showHeader: false,
    showFooter: false,
    toBeSSRed: true,
    directLanding: true,
    contentType: 'text/xml',
    toBeCached: true,
    cacheConfig: {
      getCacheKey: ({ params }) => {
        return `if-hi-flight-schedule-sitemap-${params.sitemapIndex}`;
      },
      aerospikeConfig: ({ params }) => {
        // for local aerospike setup
        // https://medium.com/@nikhilajayk/quick-setup-guide-aerospike-on-windows-in-minutes-using-docker-b45840f8ce2c
        // docker run -tid --name aerospike -p 3000:3000 -p 3001:3001 -p 3002:3002 -p 3003:3003 aerospike/aerospike-server
        const obj = {
          ip: aerospikeIp,
          port: aerospikePort,
          namespace: aerospikeNamespaceForFlights,
          set: 'flights-seo-srp',
          ttl: 60 * 60 * 24 * 365 // 365 days
        };
        return obj;
      }
    }
  },
  {
    path: ['/international-flights/hi/sitemap/if-airline-schedule-sitemap-:sitemapIndex.xml'],
    component: '',
    key: '',
    exact: true,
    inServerInit: () => {},
    showHeader: false,
    showFooter: false,
    toBeSSRed: true,
    directLanding: true,
    contentType: 'text/xml',
    toBeCached: true,
    cacheConfig: {
      getCacheKey: ({ params }) => {
        return `if-hi-airline-schedule-sitemap-${params.sitemapIndex}`;
      },
      aerospikeConfig: ({ params }) => {
        // for local aerospike setup
        // https://medium.com/@nikhilajayk/quick-setup-guide-aerospike-on-windows-in-minutes-using-docker-b45840f8ce2c
        // docker run -tid --name aerospike -p 3000:3000 -p 3001:3001 -p 3002:3002 -p 3003:3003 aerospike/aerospike-server
        const obj = {
          ip: aerospikeIp,
          port: aerospikePort,
          namespace: aerospikeNamespaceForFlights,
          set: 'flights-seo-srp',
          ttl: 60 * 60 * 24 * 365 // 365 days
        };
        return obj;
      }
    }
  },
  {
    path: ['/international-flights/sitemap/city-country-sitemap-:sitemapIndex.xml'],
    component: '',
    key: '',
    exact: true,
    inServerInit: () => {},
    showHeader: false,
    showFooter: false,
    toBeSSRed: true,
    directLanding: true,
    contentType: 'text/xml',
    toBeCached: true,
    cacheConfig: {
      getCacheKey: ({ params }) => {
        return `city-country-sitemap-${params.sitemapIndex}`;
      },
      aerospikeConfig: ({ params }) => {
        // for local aerospike setup
        // https://medium.com/@nikhilajayk/quick-setup-guide-aerospike-on-windows-in-minutes-using-docker-b45840f8ce2c
        // docker run -tid --name aerospike -p 3000:3000 -p 3001:3001 -p 3002:3002 -p 3003:3003 aerospike/aerospike-server
        const obj = {
          ip: aerospikeIp,
          port: aerospikePort,
          namespace: aerospikeNamespaceForFlights,
          set: 'flights-seo-srp',
          ttl: 60 * 60 * 24 * 365 // 365 days
        };
        return obj;
      }
    }
  }
];
